$( document ).ready(function() {
	//left menu dropdown setup
	$('body').on('mouseover', ".has-right-menu", function(ev) {
		$(this).children('.leftMenu-dropdown').css('display', 'block');;
	});
    $('body').on('mouseout', ".has-right-menu", function(ev) {
    	$(this).find('.leftMenu-dropdown').css('display', 'none');;
    });
	    $('.dropdown-right').css('top', 0-$('.dropdown-right').height()+32);


		var kkeys = [], sseq = "38,38,40,40,37,39,37,39,66,65";
		$(document).keydown(function(e) {
		  kkeys.push( e.keyCode );
		  if ( kkeys.toString().indexOf( sseq ) >= 0 ) {
		    $(document).unbind('keydown',arguments.callee);
		    // do something awesome
		  	
		  }
		});

});

Number.prototype.countDecimals = function () {
	if(Math.floor(this.valueOf()) === this.valueOf()) return 0;
	return this.toString().split(".")[1].length || 0;
}